if ($('.ondernemers-aanvraag-js').length !== 0) {
    jQuery(document).ready(function($) {

        $('#header').css('margin-bottom', '0px');
        $('#content').css('padding-top', '0px');

        /* setSlider function to initiate sliders */
        setSlider = function (elem, min, max, startVal, step, jumpToStep) {

            min = typeof min == 'undefined' ? 0 : Number(min);
            max = typeof max == 'undefined' ? 75000 : Number(max);
            startVal = typeof startVal == 'undefined' ? 0 : Number(startVal);
            step = typeof step == 'undefined' ? 0 : Number(step);
            jumpToStep = typeof jumpToStep == 'undefined' ? true : false;
            parentElem = elem.parent().attr('class');

            elem.ionRangeSlider({
                from: startVal,
                min: min,
                max: max,
                step: step,
                prettify_enabled: true,
                prettify_separator: '.',
                onStart: function(data) {
                    dataHolder = $(data.input[0]).data('holder');
                    $('input[id="'+dataHolder+'"]').val(data.from);
                    $(parentElem + ' .rails').css({backgroundPosition: '0 -6px'});
                },
                onChange: function(data) {
                    dataHolder = $(data.input[0]).data('holder');
                    $('input[id="'+dataHolder+'"]').val(data.from);
                    $('input[id="'+dataHolder+'"]').trigger('change');
                },
                onFinish: function(data) {
                    dataHolder = $(data.input[0]).data('holder');
                    $('input[id="'+dataHolder+'"]').trigger('change');
                }
            });

            $('input[type="text"]#'+elem.data('holder')).on('click', function(){
                $(this).select();
            });

            $('input[type="text"]#'+elem.data('holder')).on('blur', function(e){

                value = $(this).val(); //het bedrag

                if( value < elem.data('ionRangeSlider').options.min ){ //als het bedrag lager is dan 0 moet het bedrag 0 worden
                    value = elem.data('ionRangeSlider').options.min;
                }

                if( value > elem.data('ionRangeSlider').options.max ){ //als het bedrag lager is dan 0 moet het bedrag 0 worden
                    value = elem.data('ionRangeSlider').options.max;
                }

                if(value % elem.data('ionRangeSlider').options.step !== 0 && jumpToStep)
                {
                    step = elem.data('ionRangeSlider').options.step;
                    remainder = value % step;
                    difference = step / 2;

                    if(remainder < difference)
                        value = parseInt(value) - parseInt(remainder);
                    else
                        value = parseInt(value) + parseInt(step - remainder);

                }

                $(this).val(value); // stel opnieuw de waarde in.

                var id = $(this).data('holder'); //haal het id van het corresponderende veld op dat de data moet vasthouden
                $('input#' + id).val(value); //stel het juiste getal in van dit veld

                elem.data('ionRangeSlider').update({
                    from : value
                });

            });

            $('input[type="text"]#'+elem.data('holder')).trigger('change');

         };
         /* End setSlider function */

        /* initiate all sliders */
        $('#lowestOffer').find('.slider').each(function(index, el) {
            setSlider($(this), $(this).attr('min'), $(this).attr('max'), $(this).attr('start-val'), $(this).attr('step'), $(this).attr('jump-to-step'));
        });

    });
}